import React, { useEffect } from 'react';
import {
  Card, CardMedia, CardContent, IconButton, Typography, Popover
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: 550,
    marginBottom: '1.6rem',
  },
  media: {
    //height: 500,
    paddingTop: '100%',
  },
  expand: {
    transform: 'rotate(0deg)',
    //marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
  Ibutton: {
    borderRadius: 0,
  },
  list: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
    margin: theme.spacing(1),
  },
  textField: {
    '& > *': {
      padding: '10px',
    },
  },
  comentAction: {
    minWidth: '300px',
  },
  typography: {
    padding: theme.spacing(2),
  }
}));


export default function Publication({ news }) {

  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardMedia
        className={classes.media}
        image={news.i}
      />
      <CardContent>
        <div>
          <Typography display='inline' variant='h6'>{news.h1}</Typography>
          {/* <IconButton disabled={!permission} style={{ verticalAlign: 'bottom', float: 'right' }} onClick={handleClick} size='small' >
            <MoreVertIcon />
          </IconButton> */}
          {/* <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <button onClick={deleteNew}>
              <Typography className={classes.typography}>Eliminar</Typography>
            </button>
          </Popover> */}

        </div>
        <Typography variant='subtitle1' >{news.h2 ? news.h2 : null}</Typography>
        <Typography align='left' variant="body2" color="textSecondary" component="span">
          {news.co}
        </Typography>
      </CardContent>
    </Card>
  );


}